module.exports = __webpack_public_path__ + "media/images/career_camp/2022/events/_tribe_text-4bd5ee7a838684090ee7ca6f8e51a08a.svg";